import { useCallback } from 'react'

import { CommonExperimentJoinKeys, ExperimentPayload, ExperimentPlatformTypes, ExperimentUUIDs } from '../types'
import { generateGenericExperimentPayload } from '../utils'

export type UseSendExperimentDataProps = {
  lyraId: string
  deviceUUID: string
  postExperimentEntrypoint: (payload: ExperimentPayload) => void
  platform?: ExperimentPlatformTypes
  sessionId?: string
}

export type SendExperimentDataParams = {
  flagName: string
  experimentUUID: ExperimentUUIDs
  joinKeys?: CommonExperimentJoinKeys
  flagValue?: string
}

export type ExperimentDataParams = Omit<SendExperimentDataParams, 'flagValue' | 'flagName' | 'arm'>
export const useSendExperimentData = ({
  lyraId,
  deviceUUID,
  postExperimentEntrypoint,
  platform,
  sessionId,
}: UseSendExperimentDataProps) => {
  return useCallback(
    ({ experimentUUID, joinKeys, flagName, flagValue }: SendExperimentDataParams) => {
      const experimentPayload = generateGenericExperimentPayload({
        experimentUUID,
        deviceUUID,
        joinKeys: { ...joinKeys, client_lyra_id: lyraId, ...(sessionId ? { session_id: sessionId } : {}) },
        platform,
        flagName,
        flagValue,
      })

      // send experiment data to DS
      postExperimentEntrypoint(experimentPayload)

      return
    },
    [deviceUUID, lyraId, platform, postExperimentEntrypoint, sessionId],
  )
}
